module.exports = __webpack_public_path__ + "img/no-sale.3b2c377e.png";